/**
 * @file Project
 * @desc Manage project objects.
 */

export const Project = {
  defaults: {
    // Database properties.
    project_id: null,
    project_code: null,
    project_name: null,

    // View properties.
    billingCode: null,
    contractBillingRate: null,
    contractBillingType: null,
    contractBillingUnit: null,
    contractStatus: null,
    contractType: null,
    docs: [
      {
        href: null,
        name: 'Scoping Doc',
      },
    ],
    emailAccountManager: null,
    emailProjectSalesContact: null,
    emailProjectSupporters: [],
    emailProjectWatchers: [],
    endDate: null,
    isActive: true,
    isArchived: false,
    isDeleted: false,
    launchDateActual: null,
    launchDateEstimate: null,
    monthlyHours: 0,
    projectCode: null, // Mapped from project_code from database.
    projectDescription: '',
    projectHours: 0,
    projectId: null, // Mapped from project_id from database.
    projectName: '', // Mapped from project_name from database.
    projectStatus: null,
    projectType: null,
    startDate: null,
  },
}

export const makeProject = (project) => ({ ...Project.defaults, ...project })

export default Project
